"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StarRating = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = require("../Box/Box");

var _Icons = _interopRequireDefault(require("../Icons/Icons"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var StarRating =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(StarRating, _PureComponent);

  function StarRating() {
    _classCallCheck(this, StarRating);

    return _possibleConstructorReturn(this, _getPrototypeOf(StarRating).apply(this, arguments));
  }

  _createClass(StarRating, [{
    key: "render",
    value: function render() {
      var rating = this.props.rating;
      var nearestHalf = (Math.round(rating * 2) / 2).toString();
      var hasHalfStar = nearestHalf.length === 3;
      var arraySize = hasHalfStar ? parseInt(nearestHalf[0], 10) + 1 : parseInt(nearestHalf[0], 10);
      var arrayToGenerate = Array(arraySize).fill();
      return _react.default.createElement(_Box.Box, {
        title: "".concat(rating, " out of 5 stars"),
        display: "flex"
      }, arrayToGenerate.map(function (v, i) {
        return i === arrayToGenerate.length - 1 && hasHalfStar ? _react.default.createElement(_react.Fragment, {
          key: i
        }, _react.default.createElement(_Icons.default.StarHalf, {
          color: "textPrimary",
          key: i
        }), "\xA0") : _react.default.createElement(_react.Fragment, {
          key: i
        }, _react.default.createElement(_Icons.default.Star, {
          color: "textPrimary",
          key: i
        }), "\xA0");
      }), Array(5 - arraySize).fill().map(function (v, i) {
        return _react.default.createElement(_react.Fragment, {
          key: i
        }, _react.default.createElement(_Icons.default.Star, {
          color: "gray"
        }), "\xA0");
      }));
    }
  }]);

  return StarRating;
}(_react.PureComponent);

exports.StarRating = StarRating;
StarRating.displayName = 'StarRating'; // Prop Types

StarRating.propTypes = {
  // color
  rating: _propTypes.default.number.isRequired
};
StarRating.defaultProps = {};